﻿<template>
  <div class=" index-wrapper">
    <div class="space-center index-content">
      <div class="home-content">
        <div class="logo-area">
          <img class="logo" :src="tenantConfig.logo" alt="logo" />
        </div>
      </div>

      <div class="box-wrap full-width negative-margin-top">
        <component
          :is="componentsMap[currentAuthMode].name"
          :ref="setCurrentComponentRef"
          @change-mode="componentsMap[currentAuthMode].handler"
        />

        <!-- <div class="center LoginRegister">
          <template v-for="item in switchModeLinks" :key="item.mode">
            <p v-if="item.mode == displayMode">
              {{ $t('indexPage.' + item.text) }}
              <span class="underline-hover" @click="switchMode(item.switchMode)">
                {{ $t('indexPage.' + item.routerText) }}
              </span>
            </p>
          </template>
        </div> -->
      </div>
    </div>

    <div class="footer-wrapper">
      <div class="index-footer">
        <p class="noselect">{{ tenantConfig.extra?.copyright || $t('common.copyright') }}</p>

        <div class="footer-setting flex-center">
          <!-- <div class="lang-switch">
            <div class="lang-item" :class="{ active: isChineseLanguage }" @click="switchToChinese">
              <span class="flag">🇨🇳</span>
            </div>
            <div class="lang-item" :class="{ active: !isChineseLanguage }" @click="switchToEnglish">
              <span class="flag">🇺🇸</span>
            </div>
          </div> -->

          <div class="server-setting-text noselect" @click="openQrScanner">
            <svg class="setting-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <rect x="3" y="3" width="7" height="7" />
              <rect x="14" y="3" width="7" height="7" />
              <rect x="3" y="14" width="7" height="7" />
              <rect x="14" y="14" width="3" height="3" />
              <line x1="21" y1="14" x2="21" y2="14.01" />
              <line x1="21" y1="21" x2="21" y2="21.01" />
              <line x1="17" y1="21" x2="17" y2="21.01" />
              <line x1="21" y1="17" x2="21" y2="17.01" />
            </svg>
            扫码配置服务器
          </div>

          <div class="server-setting-text noselect" @click="showServerModal = true">
            <svg class="setting-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <circle cx="12" cy="12" r="3" />
              <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z" />
            </svg>
            手动配置服务器
          </div>
        </div>
      </div>
    </div>

    <ServerConfigModal
      ref="serverConfigModalRef"
      v-model:visible="showServerModal"
      @confirm="handleServerConfigured"
    />

    <div v-if="showQrScanner" class="qr-modal-overlay" @click.self="closeQrScanner">
      <div class="qr-modal-content">
        <div class="qr-modal-header">
          <h2>扫码配置服务器</h2>
          <button class="qr-close-btn" type="button" @click="closeQrScanner">×</button>
        </div>

        <div id="server-qr-reader" class="qr-reader"></div>

        <div class="qr-actions">
          <button class="qr-action-btn" type="button" :disabled="isQrProcessing" @click="restartQrCamera">
            重新扫码
          </button>
          <button class="qr-action-btn primary" type="button" :disabled="isQrProcessing" @click="triggerQrImageSelect">
            从相册选择
          </button>
        </div>

        <input
          ref="qrFileInputRef"
          class="qr-file-input"
          type="file"
          accept="image/*"
          @change="handleQrImageSelected"
        />

        <p class="qr-tip">{{ qrTip }}</p>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, nextTick, onBeforeUnmount } from 'vue'
import { useRouter } from 'vue-router'
import { useI18n } from 'vue-i18n'
import { Html5Qrcode } from 'html5-qrcode'
import { setLang } from '@/i18n'
import { getCurrentTenant } from '@/utils/tenant'
import { toast } from 'd3components/src/utils/tools'
import LoginComponent from './login/index.vue'
import RegisterComponent from './register/index.vue'
import ForgotPasswordComponent from './forgot-password/index.vue'

const { t } = useI18n({ useScope: 'global' })
const router = useRouter()

const showServerModal = ref(false)
const showQrScanner = ref(false)
const isQrProcessing = ref(false)
const qrTip = ref('请确保您已经获得服务器二维码')
const qrFileInputRef = ref<HTMLInputElement>()
const serverConfigModalRef = ref<any>(null)
const currentComponentRef = ref<any>(null)
const qrReaderId = 'server-qr-reader'
let html5QrCode: Html5Qrcode | null = null

const tenantConfig = getCurrentTenant()

const AUTH_MODES = {
  LOGIN: 1,
  REGISTER: 2,
  FORGOT_PASSWORD: 3,
} as const

const LANGUAGES = {
  CHINESE: 'zh-cn',
  ENGLISH: 'en-us',
} as const

const currentAuthMode: any = ref(AUTH_MODES.LOGIN)
const displayMode: any = ref(AUTH_MODES.REGISTER)
const isChineseLanguage = ref(true)

const setCurrentComponentRef = (instance: any) => {
  currentComponentRef.value = instance
}

const getCurrentComponentRef = () => currentComponentRef.value

const switchMode = async (mode: number): Promise<void> => {
  displayMode.value = mode
  if (currentAuthMode.value === mode) return

  const currentRef = getCurrentComponentRef()
  if (currentRef?.leave) {
    await currentRef.leave()
  }

  currentComponentRef.value = null
  currentAuthMode.value = mode
  await nextTick()
}

const handleServerConfigured = () => {
  console.log('服务器配置完成')
  window.location.reload()
}

const componentsMap: any = {
  [AUTH_MODES.LOGIN]: {
    name: LoginComponent,
    handler: switchMode,
  },
  [AUTH_MODES.REGISTER]: {
    name: RegisterComponent,
    handler: null,
  },
  [AUTH_MODES.FORGOT_PASSWORD]: {
    name: ForgotPasswordComponent,
    handler: null,
  },
}

const switchModeLinks = [
  {
    mode: AUTH_MODES.LOGIN,
    text: 'noAccount',
    routerText: 'applyAccount',
    switchMode: AUTH_MODES.REGISTER,
  },
  {
    mode: AUTH_MODES.REGISTER,
    text: 'hasAccount',
    routerText: 'loginNow',
    switchMode: AUTH_MODES.LOGIN,
  },
  {
    mode: AUTH_MODES.FORGOT_PASSWORD,
    text: 'rememberPassword',
    routerText: 'goLogin',
    switchMode: AUTH_MODES.LOGIN,
  },
]

const switchToChinese = () => {
  if (!isChineseLanguage.value) {
    setLang(LANGUAGES.CHINESE)
    isChineseLanguage.value = true
  }
}

const switchToEnglish = () => {
  if (isChineseLanguage.value) {
    setLang(LANGUAGES.ENGLISH)
    isChineseLanguage.value = false
  }
}

const normalizeQrServerText = (decodedText: string) => {
  const text = decodedText.trim()

  if (!text) {
    return ''
  }

  try {
    const parsed = JSON.parse(text)
    const serverValue = parsed?.host || parsed?.server || parsed?.serverUrl || parsed?.url || parsed?.api || parsed?.baseUrl
    if (typeof serverValue === 'string') {
      return serverValue.trim()
    }
  } catch (error) {
    console.log('[ServerQR] 非 JSON 二维码内容', error)
  }

  const urlMatch = text.match(/https?:\/\/[^\s"'<>，。；]+/i)
  if (urlMatch) {
    return urlMatch[0]
  }

  const ipMatch = text.match(/(?:\d{1,3}\.){3}\d{1,3}(?::\d{1,5})?/)
  if (ipMatch) {
    return ipMatch[0]
  }

  const domainMatch = text.match(/[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}(?::\d{1,5})?(?:\/[^\s"'<>，。；]*)?/)
  if (domainMatch) {
    return domainMatch[0]
  }

  return text
}

const ensureQrInstance = () => {
  if (!html5QrCode) {
    html5QrCode = new Html5Qrcode(qrReaderId)
  }
  return html5QrCode
}

const stopQrCamera = async () => {
  if (!html5QrCode) return

  try {
    if ((html5QrCode as any).isScanning) {
      await html5QrCode.stop()
    }
  } catch (error) {
    console.log('[ServerQR] 停止扫码失败', error)
  }
}

const clearQrScanner = async () => {
  if (!html5QrCode) return

  await stopQrCamera()

  try {
    html5QrCode.clear()
  } catch (error) {
    console.log('[ServerQR] 清理扫码实例失败', error)
  }

  html5QrCode = null
}

const applyQrServerConfig = async (decodedText: string, force = false) => {
  if (isQrProcessing.value && !force) return

  isQrProcessing.value = true

  try {
    const serverText = normalizeQrServerText(decodedText)

    if (!serverText) {
      toast('未识别到有效服务器地址', 2)
      return
    }

    await clearQrScanner()
    showQrScanner.value = false
    toast('识别成功，正在验证服务器', 1)
    await serverConfigModalRef.value?.confirmServer(serverText)
  } finally {
    isQrProcessing.value = false
  }
}

const startQrCamera = async () => {
  await nextTick()

  try {
    qrTip.value = '请确保您已经获得服务器二维码'
    const qrCode = ensureQrInstance()
    await qrCode.start(
      { facingMode: 'environment' },
      {
        fps: 10,
        qrbox: { width: 250, height: 250 },
      },
      (decodedText) => {
        applyQrServerConfig(decodedText)
      },
      () => {}
    )
  } catch (error) {
    console.error('[ServerQR] 打开摄像头失败', error)
    qrTip.value = '摄像头打开失败，请检查相机权限；也可以从相册选择二维码图片'
    toast('摄像头打开失败，请检查相机权限', 3)
  }
}

const openQrScanner = async () => {
  if (isQrProcessing.value) return

  const currentRef = getCurrentComponentRef()
  const hasPrivacyConsent = currentRef?.hasPrivacyConsent?.()

  if (!hasPrivacyConsent) {
    toast(t('common.agreementRequiredSingleScode'), 3)
    return
  }

  showQrScanner.value = true
  await startQrCamera()
}

const closeQrScanner = async () => {
  await clearQrScanner()
  showQrScanner.value = false
  isQrProcessing.value = false
}

const restartQrCamera = async () => {
  if (isQrProcessing.value) return

  await clearQrScanner()
  await startQrCamera()
}

const triggerQrImageSelect = () => {
  if (isQrProcessing.value) return
  qrFileInputRef.value?.click()
}

const handleQrImageSelected = async (event: Event) => {
  const input = event.target as HTMLInputElement
  const file = input.files?.[0]
  input.value = ''

  if (!file || isQrProcessing.value) return

  isQrProcessing.value = true
  qrTip.value = '正在识别图片二维码...'

  try {
    await stopQrCamera()
    const qrCode = ensureQrInstance()
    const decodedText = await qrCode.scanFile(file, true)
    await applyQrServerConfig(decodedText, true)
  } catch (error) {
    console.error('[ServerQR] 图片二维码识别失败', error)
    toast('未识别到二维码，请重新选择图片', 3)
  } finally {
    if (showQrScanner.value) {
      isQrProcessing.value = false
      qrTip.value = '请将二维码对准扫描框，也可以从相册选择二维码图片'
    }
  }
}

onBeforeUnmount(() => {
  clearQrScanner()
})
</script>

<style scoped lang="scss">
$text-secondary: #8a94a6;
$accent-color: var(--color-primary);
$animation-duration-fast: 0.25s;
$animation-duration-normal: 0.55s;
$animation-duration-slow: 3s;
$logo-size: 150px;
$flag-size: 20px;
$gap-small: 0.3rem;
$gap-normal: 0.75rem;
$gap-large: 0.9rem;
$border-radius-full: 50%;

.noselect{
   -webkit-user-select: none; /* Safari */
  -moz-user-select: none;    /* Firefox */
  -ms-user-select: none;    /* Internet Explorer/Edge */
  user-select: none;        /* Standard syntax */
}
.center {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.space-center {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
}

.flex-center {
  display: flex;
  align-items: center;
}

.full-width {
  width: 100%;
}

.negative-margin-top {
  margin-top: -20%;
}

.box-wrap {
  user-select: none;
}

.footer-setting {
  justify-content: center;
  margin-top: 0.25rem;
  gap: 0.35rem;
}

.server-setting-text {
  display: flex;
  align-items: center;
  gap: 0.2rem;
  cursor: pointer;
  color: var(--color-text);
  font-size: 0.75rem;
  padding: 0.2rem 0.4rem;
  border-radius: 0.3rem;
  transition: background 0.2s;

  &:active {
    background: rgba(0, 0, 0, 0.05);
  }

  .setting-icon {
    width: 0.85rem;
    height: 0.85rem;
    flex-shrink: 0;
    stroke: var(--color-primary, #398cfe);
  }
}

.index-wrapper {
  height: 100vh;
  width: 100vw;
  overflow: auto;
//   background: var(--gradient-background, linear-gradient(180deg, rgba(57, 140, 254, 0.15) 0%, rgba(255, 255, 255, 1) 50%));
  position: relative;
  background-color: var(--color-body);
  padding-bottom: calc(70px + env(safe-area-inset-bottom));

  .index-content {
    width: 100%;
    position: relative;
    z-index: 1;

    .LoginRegister {
      margin-top: 5%;

      & > p {
        font-size: 0.85rem;
        color: $text-secondary;

        & > span {
          cursor: pointer;
          color: $accent-color;
          font-weight: 700;
        }
      }
    }
  }

  .index-footer {
      margin-top:calc( 60% + env(safe-area-inset-bottom));
    // color: $text-secondary;
    color: var(--color-text);
    font-size: 0.85rem;
   
    & > p {
      display: flex;
      justify-content: center;
      align-items: center;
      gap: $gap-large;
      margin-top: 2%;
      user-select: none;
    }

    & > div{
        user-select: none;
    }

    .lang-switch {
      display: flex;
      justify-content: center;
      align-items: center;
      gap: $gap-normal;
      margin-right: $gap-normal;
      user-select: none;
      .lang-item {
        width: 40px;
        height: 40px;
        border-radius: $border-radius-full;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        transition: all $animation-duration-normal ease;
        border: 2px solid transparent;
    user-select: none;
        .flag {
          font-size: $flag-size;
          line-height: 1;
        }

        &:hover {
          transform: scale(1.1);
          background: rgba(255, 255, 255, 0.9);
        }

        &.active {
          border-color: $accent-color;
        }
      }
    }
  }
}


.home-content {
  width: 100%;
  height: 380px;

  .logo-area {
    margin-top: 70px;
    display: flex;
    justify-content: center;

    .logo {
      width: $logo-size;
      height: $logo-size;
      object-fit: contain;
      animation: logoFloat $animation-duration-slow ease-in-out infinite;
    }
  }
}

.underline-hover {
  display: inline-block;
  cursor: pointer;
  padding-bottom: $gap-small;
  background-image: linear-gradient(#000, #000);
  background-repeat: no-repeat;
  background-position: center bottom;
  background-size: 0% 2px;
  transition: background-size $animation-duration-fast ease;

  &:hover {
    background-size: 100% 2px;
  }
}

.qr-modal-overlay {
  position: fixed;
  inset: 0;
  z-index: 10000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.8rem;
  background: rgba(0, 0, 0, 0.55);
}

.qr-modal-content {
  width: 100%;
  max-width: 680px;
  max-height: 90vh;
  overflow-y: auto;
  border-radius: 18px;
  background-color: var(--D3-bg-color-container);
  padding: 0.8rem;
  box-sizing: border-box;
}

.qr-modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 0.6rem;

  h2 {
    margin: 0;
    color: var(--color-text);
    font-size: 0.95rem;
    font-weight: 600;
  }
}

.qr-close-btn {
  width: 1.4rem;
  height: 1.4rem;
  border: 0;
  border-radius: 50%;
  background: rgba(0, 0, 0, 0.08);
  color: var(--color-text);
  cursor: pointer;
  font-size: 1rem;
  line-height: 1;
}

.qr-reader {
  overflow: hidden;
  min-height: 280px;
  border-radius: 12px;
  background: #000;
}

.qr-actions {
  display: flex;
  gap: 0.5rem;
  margin-top: 0.7rem;
}

.qr-action-btn {
  flex: 1;
  height: 2rem;
  border: 1px solid var(--D3-border-color);
  border-radius: 0.35rem;
  background: var(--card-background);
  color: var(--D3-font-color);
  cursor: pointer;
  font-size: 0.72rem;
}

.qr-action-btn.primary {
  border: 0;
  background: linear-gradient(135deg, rgba(57, 140, 254, 1) 0%, rgba(26, 111, 220, 1) 100%);
  color: #fff;
}

.qr-action-btn:disabled {
  cursor: not-allowed;
  opacity: 0.6;
}

.qr-file-input {
  display: none;
}

.qr-tip {
  margin: 0.6rem 0 0;
  color: $text-secondary;
  font-size: 0.65rem;
  text-align: center;
}

:deep(#server-qr-reader video) {
  border-radius: 12px;
}

:deep(#server-qr-reader__dashboard_section_csr button),
:deep(#server-qr-reader__dashboard button) {
  border: 0;
  border-radius: 0.3rem;
  background: rgba(57, 140, 254, 1);
  color: #fff;
}

@keyframes logoFloat {
  0%, 100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-15px);
  }
}
</style>